import React, { FunctionComponent, PropsWithChildren } from 'react';

import * as OrbModal from '@yandex-360/orb-components/dist/components/Modal2';

import css from './styles.css';

export interface ModalProps extends PropsWithChildren<OrbModal.ModalProps> {
    title: string;
}

export const Modal: FunctionComponent<ModalProps> = ({ title, children, ...props }) => {
    return (
        <OrbModal.Modal {...props}>
            <OrbModal.NavigationBar title={title} closable />
            <OrbModal.Slot className={css.container}>{children}</OrbModal.Slot>
        </OrbModal.Modal>
    );
};

Modal.displayName = 'SettingsModal.Modal';
